import { Warning } from 'components/Icons';
import styled from 'styled-components/macro';

interface Props {
  hasErrors?: boolean;
  errorMessage?: string;
}

export function ErrorWarning({ hasErrors, errorMessage = '' }: Props) {
  return (
    <>
      {hasErrors ? (
        <Error>
          <Warning size='13px' className='m-1' fill='#AA0101' />
          <ErrorText>{errorMessage}</ErrorText>
        </Error>
      ) : null}
    </>
  );
}

const Error = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
`;

const ErrorText = styled.div`
  color: rgb(207, 72, 69);
  font-size: 12px;
  padding-top: 2px;
`;
